import { getBase44 } from '@/api/base44Lazy';

export async function reportError(context, err, toast) {
  // Extract the actual error message from the response or error object
  let errorMsg = 'An unexpected error occurred. Please try again.';
  if (err?.response?.data?.error) {
    errorMsg = err.response.data.error;
  } else if (err?.message) {
    errorMsg = err.message;
  }

  // Show the user the actual error
  if (toast) {
    toast({ title: 'Error', description: errorMsg, variant: 'destructive' });
  }

  // Email victor@daleyinventories.com with the error details (fire and forget)
  try {
    const base44 = await getBase44();
    await base44.functions.invoke('send-notification', {
      to: 'victor@daleyinventories.com',
      subject: `Website Error Alert - ${context}`,
      body: `An error occurred on the Daley Inventories website.

Context: ${context}
Time: ${new Date().toISOString()}

Error message:
${errorMsg}

Error details:
${JSON.stringify(err?.response?.data || err, null, 2)}

Stack:
${err?.stack || 'N/A'}`,
    });
  } catch {
    // silently fail — don't block the user experience
  }
}